import { Helmet } from "react-helmet-async";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "PsychologicalTreatment",
  name: "Instituto Maré Psicologia",
  description:
    "Psicologia clínica com método e presença. Atendimento para crianças, adolescentes, adultos e famílias em Itanhaém-SP e online para todo o Brasil.",
  url: "https://www.mareinstituto.com.br",
  telephone: "+55-13-99155-9901",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Itanhaém",
    addressRegion: "SP",
    addressCountry: "BR",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: -24.1831,
    longitude: -46.7889,
  },
  areaServed: [
    { "@type": "City", name: "Itanhaém" },
    { "@type": "Country", name: "Brasil" },
  ],
  serviceType: [
    "Psicoterapia infantil",
    "Psicoterapia para adolescentes",
    "Psicoterapia para adultos",
    "Terapia familiar",
    "Adequação NR-1",
    "Avaliação psicossocial",
    "Atendimento psicológico online",
  ],
  provider: {
    "@type": "Person",
    name: "Marcella Nunes Basso Zanella Charif",
    jobTitle: "Psicóloga",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "18:00",
    },
  ],
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Instituto Maré Psicologia",
  url: "https://www.mareinstituto.com.br",
  logo: "https://www.mareinstituto.com.br/favicon.svg",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+55-13-99155-9901",
    contactType: "customer service",
    availableLanguage: "Portuguese",
    areaServed: "BR",
  },
  sameAs: [
    "https://www.instagram.com/institutomarepsicologia",
  ],
};

export function StructuredData() {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
}
